import debounce from "lodash.debounce"

const loadedClass = 'loaded'
const bgMediaEls  = document.querySelectorAll('.bg-media--video')

const init = () => {
	window.addEventListener('resize', debounce(checkSize, 100), false)
	checkSize()
}

const checkSize = () => {

	// Loop through iframes in bg-media elements
	for (const el of bgMediaEls) {
		
		el.classList.remove(loadedClass)

		const iframeEl = el.querySelector('iframe')

		const iframeW = iframeEl.offsetWidth
		const iframeH = iframeEl.offsetHeight
		const parentW = iframeEl.parentElement.offsetWidth
		const parentH = iframeEl.parentElement.offsetHeight

		const iframeIntrinsic         = iframeH/iframeW
		const iframeInstrinsicPercent = iframeIntrinsic * 100
		const aspectRatio             = iframeW/iframeH
		
		// Set iframe width to be same as parent
		const newW = parentW
		const newH = parentW * iframeIntrinsic

		// If iframe height less than parent height, use parent height and calculate new width
		if (newH < parentH) {
			newH = parentH
			newW = newH * aspectRatio
		}

		iframeEl.setAttribute('width', newW)
		iframeEl.setAttribute('height', newH)

		el.classList.add(loadedClass)
	}
}

export default init;